module.exports = __webpack_public_path__ + "fonts/edb47908205367afefa86ad5bcd01c77.txt";